<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-center">
      <ReviewsStars
        :rating="averageRating"
      />
      <span class="text-EXPONDO-secondary">
        {{ `(${ratingCount})` }}
      </span>
    </div>
    <ProductFinalPrice
      :final-price="finalPrice"
      :is-discounted="isDiscounted"
      class="text-xl"
    />
    <div class="line-clamp-2 min-h-12">
      {{ product._name }}
    </div>
    <ProductCardBadges
      :tags="productTags"
    />
    <div
      v-if="isCurrentSku"
      class="text-EXPONDO-green border border-EXPONDO-white flex flex-col justify-center"
    >
      <div class="min-h-12 flex items-center gap-2">
        <span class="iconify svg--check-solid" />
        <span class="text-sm">{{ $t('Currently seen') }}</span>
      </div>
    </div>
    <CustomButton
      v-else
      :text="$t('See product')"
      type="secondary"
    />
  </div>
</template>

<script lang="ts">

import { productGetters } from '~/utils/ct';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';
import type { ProductTag } from '~~/types/product/attribute/ProductTag';

export default defineComponent({
  name: 'AlternativeProductDetails',

  props: {
    product: {
      type: Object as PropType<ProductVariantExtended>,
      required: true,
    },
    currentSku: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const { product } = toRefs(props);
    const { getPriceInformation } = useProductPrice();
    const { languageAndCountry } = useLocalization();

    const { finalPrice, isDiscounted } = getPriceInformation(product);

    const isCurrentSku = computed<boolean>(() => props.product.sku === props.currentSku);
    const averageRating = computed<number>(() => productGetters.getAverageRating(props.product));
    const ratingCount = computed<number>(() => productGetters.getTotalReviews(props.product));

    const productTags = computed<ProductTag[]>(() => {

      const attributes = getProductAttributesExtended(product.value,
        {
          attributeNames: [PRODUCT_ATTRIBUTES.TAGS],
          languageAndCountry: languageAndCountry.value,
        });

      return attributes?.tags || [];
    
    });

    return {
      finalPrice,
      isDiscounted,
      isCurrentSku,
      averageRating,
      ratingCount,
      productTags,
    };
  
  },
});


</script>
